module.exports = __webpack_public_path__ + "static/media/boo.d67430aa.png";